module.exports = __webpack_public_path__ + "img/02_uk.d2ab9808.svg";